import React from 'react';
import GraphicEditorApp from 'components/graphicEditor/GraphicEditorApp';

function GraphicEditorPage() {
  return <GraphicEditorApp />;
}

export default GraphicEditorPage;
